import { useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const useJobs = (searchTerm = "") => {
  const [jobs, setJobs] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { getAccessTokenSilently } = useAuth0()
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchJobs = async () => {
        try {
            setError(null)
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                }
            });
            const response = await fetch(`${apiUrl}/api/positions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json().catch(() => null);

            if (!response.ok) {
                const message = data?.title || data?.message || response.statusText || "Failed to fetch jobs"
                throw new Error(message)
            }

            if (!Array.isArray(data)) {
                throw new Error("Jobs response was not a list")
            }

            setJobs(data);
        }  catch (err) {
            setJobs([])
            setError(err instanceof Error ? err.message : "An error occurred")
        } finally {
            setLoading(false)
        }
    };

    fetchJobs()
  }, [apiUrl, searchTerm, getAccessTokenSilently])

  return { jobs, loading, error }
}

